export default __webpack_public_path__ + "static/media/circular-black.5f7fb54a.woff";